var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rupee-circle-line-svgrepo-com 1",
    clipPath: "url(#clip0_72_571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0001 18.3337C14.6026 18.3337 18.3334 14.6028 18.3334 10.0003C18.3334 5.39783 14.6026 1.66699 10.0001 1.66699C5.39758 1.66699 1.66675 5.39783 1.66675 10.0003C1.66675 14.6028 5.39758 18.3337 10.0001 18.3337Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.66656 5.83301H9.16656M9.16656 5.83301H13.3332M9.16656 5.83301C9.9999 5.83301 11.6666 6.33301 11.6666 8.33301M13.3332 8.33301H11.6666M11.6666 8.33301H6.66406M11.6666 8.33301C11.6666 10.333 9.9999 10.833 9.16656 10.833H6.66406L10.8332 14.1663",
    stroke: "#9CA3AF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_72_571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/Finance.19d0b988b8e7a19d3998041d1dc2743a.svg";
export { ForwardRef as ReactComponent };